module.exports = __webpack_public_path__ + "static/media/bockav-ikon.e70c57dc.png";